/** Jurisio Firm Word add-in client — not available until the Firm host ships (spec §7.2, spike P5). */

import { PRODUCTS } from "../config";
import { BackendError, type ChatBackend, type WordBackend } from "./types";

const NOT_YET = "Jurisio Firm in Word is not available yet.";

function notYet(): never {
  throw new BackendError(NOT_YET, 501);
}

export function createFirmBackend(): WordBackend {
  return {
    config: PRODUCTS.firm,
    startPair: async () => notYet(),
    pollPair: async () => notYet(),
    getSession: async () => notYet(),
    activity: async () => notYet(),
    revoke: async () => notYet(),
  };
}

export function createFirmChatBackend(): ChatBackend {
  return {
    config: PRODUCTS.firm,
    initSnapshot: async () => notYet(),
    uploadSnapshot: async () => notYet(),
    createJob: async () => notYet(),
    pollJob: async () => notYet(),
    waitForJob: async () => notYet(),
    listVersions: async () => notYet(),
    saveVersion: async () => notYet(),
    deleteVersion: async () => notYet(),
    updateEllaComments: async () => notYet(),
  };
}
